import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/oanda_loader.gif'


const _withScopeId = n => (_pushScopeId("data-v-e33dd876"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  "data-testid": "step-clientZoneLogin",
  class: "container"
}
const _hoisted_2 = {
  key: 0,
  class: "container__standard-header container__standard-header--modify"
}
const _hoisted_3 = {
  key: 1,
  class: "container__standard-header container__standard-header--modify"
}
const _hoisted_4 = { class: "row--log-into-client-zone" }
const _hoisted_5 = {
  key: 0,
  class: "loader__gif",
  src: _imports_0,
  alt: ""
}
const _hoisted_6 = {
  key: 1,
  class: "client-zone-loader"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.showSecondHeader)
      ? (_openBlock(), _createElementBlock("h1", _hoisted_2, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.redirectToTheClientZoneHeaderOne`)), 1))
      : (_openBlock(), _createElementBlock("h1", _hoisted_3, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.redirectToTheClientZoneHeaderTwo`)), 1)),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.UtilityHelper.isOandaPath())
        ? (_openBlock(), _createElementBlock("img", _hoisted_5))
        : (_openBlock(), _createElementBlock("div", _hoisted_6))
    ]),
    _createElementVNode("p", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.dontRefresh`)), 1)
  ]))
}